import React from 'react';
import { DEFAULT_ICON_SIZE } from '../../constants';
import type { GoIconProps } from '../../types';

const GoArrowRightIcon = ({ size = DEFAULT_ICON_SIZE, color = 'currentColor' }: GoIconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 16 16">
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.6}
            d="M13 8 8.219 4M13 8l-4.781 4M13 8H3"
        />
    </svg>
);
GoArrowRightIcon.id = 'GoArrowRightIcon';
GoArrowRightIcon.displayName = 'GoArrowRightIcon';
export default GoArrowRightIcon;
